const logo = {
  logo: {
    ratio: 4.5,
    width: 1,
    height: 0.2222222222222222,
    rows: 2,
    cols: 13,
    words: ['DESIGN', 'SYSTEMS', 'INTERNATIONAL'],
    rowHeight: 0.1111111111111111,
    fontSize: 0.08888888888888889,
    wordGap: 0.015,
    startGap: 0.015,
    endGap: 0.015,
    fontYOffset: 0.08844444444444444,
    numFrames: 26,
    chars: [
      {
        bit: {
          char: 'D',
          width: 0.06391111111111111,
          isWordFirst: true,
          isWordLast: false,
          color: 0
        },
        char: 'D',
        frames: [
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.08655555555555555,
            charX: 0.015
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.8973777777777779,
            y: 0.1111111111111111,
            w: 0.10262222222222223,
            charX: 0.02371111111111111
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.8220999999999999,
            y: 0.1111111111111111,
            w: 0.09680000000000001,
            charX: 0.02394444444444445
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.7450888888888889,
            y: 0.1111111111111111,
            w: 0.0962,
            charX: 0.02364444444444444
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.6957666666666665,
            y: 0.1111111111111111,
            w: 0.09915555555555555,
            charX: 0.02512222222222222
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.6102666666666666,
            y: 0.1111111111111111,
            w: 0.09876296296296296,
            charX: 0.02492592592592592
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.5276592592592593,
            y: 0.1111111111111111,
            w: 0.09876296296296297,
            charX: 0.024925925925925928
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.4360351851851852,
            y: 0.1111111111111111,
            w: 0.09586296296296296,
            charX: 0.02347592592592592
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.3653277777777777,
            y: 0.1111111111111111,
            w: 0.09578888888888888,
            charX: 0.023438888888888884
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.31540555555555555,
            y: 0.1111111111111111,
            w: 0.09254444444444444,
            charX: 0.021816666666666665
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.2371611111111111,
            y: 0.1111111111111111,
            w: 0.09372222222222222,
            charX: 0.022405555555555554
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.16029444444444446,
            y: 0.1111111111111111,
            w: 0.09418888888888889,
            charX: 0.02263888888888889
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.08832777777777778,
            y: 0.1111111111111111,
            w: 0.09245555555555555,
            charX: 0.02177222222222222
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08655555555555555,
            charX: 0.015
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.8973777777777779,
            y: 0,
            w: 0.10262222222222223,
            charX: 0.02371111111111111
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.8220999999999999,
            y: 0,
            w: 0.09680000000000001,
            charX: 0.02394444444444445
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.7450888888888889,
            y: 0,
            w: 0.0962,
            charX: 0.02364444444444444
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.6957666666666665,
            y: 0,
            w: 0.09915555555555555,
            charX: 0.02512222222222222
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.6102666666666666,
            y: 0,
            w: 0.09876296296296296,
            charX: 0.02492592592592592
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.5276592592592593,
            y: 0,
            w: 0.09876296296296297,
            charX: 0.024925925925925928
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.4360351851851852,
            y: 0,
            w: 0.09586296296296296,
            charX: 0.02347592592592592
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.3653277777777777,
            y: 0,
            w: 0.09578888888888888,
            charX: 0.023438888888888884
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.31540555555555555,
            y: 0,
            w: 0.09254444444444444,
            charX: 0.021816666666666665
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.2371611111111111,
            y: 0,
            w: 0.09372222222222222,
            charX: 0.022405555555555554
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.16029444444444446,
            y: 0,
            w: 0.09418888888888889,
            charX: 0.02263888888888889
          },
          {
            bit: {
              char: 'D',
              width: 0.06391111111111111,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.08832777777777778,
            y: 0,
            w: 0.09245555555555555,
            charX: 0.02177222222222222
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'E',
          width: 0.05715555555555556,
          isWordFirst: false,
          isWordLast: false,
          color: 0
        },
        char: 'E',
        frames: [
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.08655555555555555,
            y: 0,
            w: 0.07244444444444444,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.08030925925925926,
            charX: 0.015
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.9188999999999999,
            y: 0.1111111111111111,
            w: 0.0811,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.8412888888888889,
            y: 0.1111111111111111,
            w: 0.07444444444444444,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7949222222222221,
            y: 0.1111111111111111,
            w: 0.0774,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7090296296296296,
            y: 0.1111111111111111,
            w: 0.0770074074074074,
            charX: 0.009925925925925921
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6264222222222222,
            y: 0.1111111111111111,
            w: 0.07700740740740741,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5318981481481482,
            y: 0.1111111111111111,
            w: 0.0741074074074074,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.46111666666666656,
            y: 0.1111111111111111,
            w: 0.07403333333333333,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.40795,
            y: 0.1111111111111111,
            w: 0.07078888888888889,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.3308833333333333,
            y: 0.1111111111111111,
            w: 0.07196666666666666,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.25448333333333334,
            y: 0.1111111111111111,
            w: 0.07243333333333334,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.18078333333333335,
            y: 0.1111111111111111,
            w: 0.0707,
            charX: 0.006772222222222221
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.08655555555555555,
            y: 0.1111111111111111,
            w: 0.07244444444444444,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08030925925925926,
            charX: 0.015
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.9188999999999999,
            y: 0,
            w: 0.0811,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.8412888888888889,
            y: 0,
            w: 0.07444444444444444,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7949222222222221,
            y: 0,
            w: 0.0774,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7090296296296296,
            y: 0,
            w: 0.0770074074074074,
            charX: 0.009925925925925921
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6264222222222222,
            y: 0,
            w: 0.07700740740740741,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5318981481481482,
            y: 0,
            w: 0.0741074074074074,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.46111666666666656,
            y: 0,
            w: 0.07403333333333333,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.40795,
            y: 0,
            w: 0.07078888888888889,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.3308833333333333,
            y: 0,
            w: 0.07196666666666666,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.25448333333333334,
            y: 0,
            w: 0.07243333333333334,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.18078333333333335,
            y: 0,
            w: 0.0707,
            charX: 0.006772222222222221
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'S',
          width: 0.06062222222222223,
          isWordFirst: false,
          isWordLast: false,
          color: 0
        },
        char: 'S',
        frames: [
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.15899999999999997,
            y: 0,
            w: 0.07591111111111111,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.08030925925925926,
            y: 0,
            w: 0.07692962962962964,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.0835425925925926,
            charX: 0.015
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.9157333333333333,
            y: 0.1111111111111111,
            w: 0.08426666666666667,
            charX: 0.008644444444444442
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.8723222222222221,
            y: 0.1111111111111111,
            w: 0.08086666666666667,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.786037037037037,
            y: 0.1111111111111111,
            w: 0.08047407407407407,
            charX: 0.009925925925925921
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7034296296296296,
            y: 0.1111111111111111,
            w: 0.08047407407407409,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6060055555555556,
            y: 0.1111111111111111,
            w: 0.07757407407407407,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5351499999999999,
            y: 0.1111111111111111,
            w: 0.0775,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.4787388888888889,
            y: 0.1111111111111111,
            w: 0.07425555555555556,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.40285,
            y: 0.1111111111111111,
            w: 0.07543333333333334,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.3269166666666667,
            y: 0.1111111111111111,
            w: 0.07590000000000001,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.25148333333333334,
            y: 0.1111111111111111,
            w: 0.07416666666666667,
            charX: 0.006772222222222221
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.15899999999999997,
            y: 0.1111111111111111,
            w: 0.07591111111111111,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.08030925925925926,
            y: 0.1111111111111111,
            w: 0.07692962962962964,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.0835425925925926,
            charX: 0.015
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.9157333333333333,
            y: 0,
            w: 0.08426666666666667,
            charX: 0.008644444444444442
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.8723222222222221,
            y: 0,
            w: 0.08086666666666667,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.786037037037037,
            y: 0,
            w: 0.08047407407407407,
            charX: 0.009925925925925921
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7034296296296296,
            y: 0,
            w: 0.08047407407407409,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6060055555555556,
            y: 0,
            w: 0.07757407407407407,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5351499999999999,
            y: 0,
            w: 0.0775,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.4787388888888889,
            y: 0,
            w: 0.07425555555555556,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.40285,
            y: 0,
            w: 0.07543333333333334,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.3269166666666667,
            y: 0,
            w: 0.07590000000000001,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.25148333333333334,
            y: 0,
            w: 0.07416666666666667,
            charX: 0.006772222222222221
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'I',
          width: 0.02168888888888889,
          isWordFirst: false,
          isWordLast: false,
          color: 0
        },
        char: 'I',
        frames: [
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.23491111111111107,
            y: 0,
            w: 0.03697777777777777,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.1572388888888889,
            y: 0,
            w: 0.03799629629629629,
            charX: 0.008153703703703701
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.0835425925925926,
            y: 0,
            w: 0.03752962962962962,
            charX: 0.007920370370370366
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.04490925925925925,
            charX: 0.015
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.9531888888888888,
            y: 0.1111111111111111,
            w: 0.04681111111111111,
            charX: 0.010122222222222218
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.866511111111111,
            y: 0.1111111111111111,
            w: 0.04154074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7839037037037038,
            y: 0.1111111111111111,
            w: 0.04154074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6835796296296297,
            y: 0.1111111111111111,
            w: 0.03864074074074073,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6126499999999999,
            y: 0.1111111111111111,
            w: 0.03856666666666665,
            charX: 0.008438888888888881
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5529944444444445,
            y: 0.1111111111111111,
            w: 0.03532222222222221,
            charX: 0.006816666666666662
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.47828333333333334,
            y: 0.1111111111111111,
            w: 0.03649999999999999,
            charX: 0.007405555555555551
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.4028166666666667,
            y: 0.1111111111111111,
            w: 0.03696666666666666,
            charX: 0.007638888888888886
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.32565,
            y: 0.1111111111111111,
            w: 0.035233333333333325,
            charX: 0.006772222222222218
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.23491111111111107,
            y: 0.1111111111111111,
            w: 0.03697777777777777,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.1572388888888889,
            y: 0.1111111111111111,
            w: 0.03799629629629629,
            charX: 0.008153703703703701
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.0835425925925926,
            y: 0.1111111111111111,
            w: 0.03752962962962962,
            charX: 0.007920370370370366
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.04490925925925925,
            charX: 0.015
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.9531888888888888,
            y: 0,
            w: 0.04681111111111111,
            charX: 0.010122222222222218
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.866511111111111,
            y: 0,
            w: 0.04154074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7839037037037038,
            y: 0,
            w: 0.04154074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6835796296296297,
            y: 0,
            w: 0.03864074074074073,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6126499999999999,
            y: 0,
            w: 0.03856666666666665,
            charX: 0.008438888888888881
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5529944444444445,
            y: 0,
            w: 0.03532222222222221,
            charX: 0.006816666666666662
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.47828333333333334,
            y: 0,
            w: 0.03649999999999999,
            charX: 0.007405555555555551
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.4028166666666667,
            y: 0,
            w: 0.03696666666666666,
            charX: 0.007638888888888886
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.32565,
            y: 0,
            w: 0.035233333333333325,
            charX: 0.006772222222222218
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'G',
          width: 0.06702222222222222,
          isWordFirst: false,
          isWordLast: false,
          color: 0
        },
        char: 'G',
        frames: [
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.27188888888888885,
            y: 0,
            w: 0.0823111111111111,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.19523518518518518,
            y: 0,
            w: 0.08332962962962963,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.12107222222222222,
            y: 0,
            w: 0.08286296296296296,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.04490925925925925,
            y: 0,
            w: 0.08346296296296295,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.08876481481481481,
            charX: 0.015
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.9080518518518518,
            y: 0.1111111111111111,
            w: 0.09194814814814814,
            charX: 0.009925925925925923
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.8254444444444445,
            y: 0.1111111111111111,
            w: 0.08687407407407408,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7222203703703705,
            y: 0.1111111111111111,
            w: 0.08397407407407406,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6512166666666666,
            y: 0.1111111111111111,
            w: 0.08389999999999999,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5883166666666667,
            y: 0.1111111111111111,
            w: 0.08065555555555555,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5147833333333334,
            y: 0.1111111111111111,
            w: 0.08183333333333333,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.43978333333333336,
            y: 0.1111111111111111,
            w: 0.0823,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.36088333333333333,
            y: 0.1111111111111111,
            w: 0.08056666666666666,
            charX: 0.006772222222222221
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.27188888888888885,
            y: 0.1111111111111111,
            w: 0.0823111111111111,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.19523518518518518,
            y: 0.1111111111111111,
            w: 0.08332962962962963,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.12107222222222222,
            y: 0.1111111111111111,
            w: 0.08286296296296296,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.04490925925925925,
            y: 0.1111111111111111,
            w: 0.08346296296296295,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08876481481481481,
            charX: 0.015
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.9080518518518518,
            y: 0,
            w: 0.09194814814814814,
            charX: 0.009925925925925923
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.8254444444444445,
            y: 0,
            w: 0.08687407407407408,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.7222203703703705,
            y: 0,
            w: 0.08397407407407406,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6512166666666666,
            y: 0,
            w: 0.08389999999999999,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5883166666666667,
            y: 0,
            w: 0.08065555555555555,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.5147833333333334,
            y: 0,
            w: 0.08183333333333333,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.43978333333333336,
            y: 0,
            w: 0.0823,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'G',
              width: 0.06702222222222222,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.36088333333333333,
            y: 0,
            w: 0.08056666666666666,
            charX: 0.006772222222222221
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'N',
          width: 0.06275555555555555,
          isWordFirst: false,
          isWordLast: true,
          color: 0
        },
        char: 'N',
        frames: [
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.35419999999999996,
            y: 0,
            w: 0.09304444444444443,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.2785648148148148,
            y: 0,
            w: 0.09406296296296296,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.20393518518518516,
            y: 0,
            w: 0.09359629629629629,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.1283722222222222,
            y: 0,
            w: 0.09419629629629628,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.08876481481481481,
            y: 0,
            w: 0.09124074074074073,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.09969444444444443,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.9123185185185186,
            y: 0.1111111111111111,
            w: 0.08768148148148147,
            charX: 0.009925925925925927
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.8061944444444445,
            y: 0.1111111111111111,
            w: 0.09470740740740739,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.7351166666666665,
            y: 0.1111111111111111,
            w: 0.09463333333333332,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.6689722222222223,
            y: 0.1111111111111111,
            w: 0.09138888888888888,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.5966166666666667,
            y: 0.1111111111111111,
            w: 0.09256666666666666,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.5220833333333333,
            y: 0.1111111111111111,
            w: 0.09303333333333333,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.44145,
            y: 0.1111111111111111,
            w: 0.09129999999999999,
            charX: 0.006772222222222221
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.35419999999999996,
            y: 0.1111111111111111,
            w: 0.09304444444444443,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.2785648148148148,
            y: 0.1111111111111111,
            w: 0.09406296296296296,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.20393518518518516,
            y: 0.1111111111111111,
            w: 0.09359629629629629,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.1283722222222222,
            y: 0.1111111111111111,
            w: 0.09419629629629628,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.08876481481481481,
            y: 0.1111111111111111,
            w: 0.09124074074074073,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.09969444444444443,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.9123185185185186,
            y: 0,
            w: 0.08768148148148147,
            charX: 0.009925925925925927
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.8061944444444445,
            y: 0,
            w: 0.09470740740740739,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.7351166666666665,
            y: 0,
            w: 0.09463333333333332,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.6689722222222223,
            y: 0,
            w: 0.09138888888888888,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.5966166666666667,
            y: 0,
            w: 0.09256666666666666,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.5220833333333333,
            y: 0,
            w: 0.09303333333333333,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.44145,
            y: 0,
            w: 0.09129999999999999,
            charX: 0.006772222222222221
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'S',
          width: 0.06062222222222223,
          isWordFirst: true,
          isWordLast: false,
          color: 1
        },
        char: 'S',
        frames: [
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.4472444444444444,
            y: 0,
            w: 0.09091111111111111,
            charX: 0.02264444444444444
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.3726277777777778,
            y: 0,
            w: 0.09192962962962964,
            charX: 0.023153703703703704
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.29753148148148145,
            y: 0,
            w: 0.09146296296296297,
            charX: 0.02292037037037037
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.22256851851851847,
            y: 0,
            w: 0.09206296296296296,
            charX: 0.023220370370370363
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.18000555555555553,
            y: 0,
            w: 0.08910740740740741,
            charX: 0.02174259259259259
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.09969444444444443,
            y: 0,
            w: 0.0895,
            charX: 0.021938888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.08381111111111111,
            charX: 0.015
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.9009018518518519,
            y: 0.1111111111111111,
            w: 0.09909814814814816,
            charX: 0.02347592592592592
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.8297499999999999,
            y: 0.1111111111111111,
            w: 0.0925,
            charX: 0.023438888888888884
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.7603611111111112,
            y: 0.1111111111111111,
            w: 0.08925555555555556,
            charX: 0.021816666666666665
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.6891833333333334,
            y: 0.1111111111111111,
            w: 0.09043333333333334,
            charX: 0.022405555555555554
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.6151166666666666,
            y: 0.1111111111111111,
            w: 0.09090000000000001,
            charX: 0.02263888888888889
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.5327500000000001,
            y: 0.1111111111111111,
            w: 0.08916666666666667,
            charX: 0.02177222222222222
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.4472444444444444,
            y: 0.1111111111111111,
            w: 0.09091111111111111,
            charX: 0.02264444444444444
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.3726277777777778,
            y: 0.1111111111111111,
            w: 0.09192962962962964,
            charX: 0.023153703703703704
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.29753148148148145,
            y: 0.1111111111111111,
            w: 0.09146296296296297,
            charX: 0.02292037037037037
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.22256851851851847,
            y: 0.1111111111111111,
            w: 0.09206296296296296,
            charX: 0.023220370370370363
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.18000555555555553,
            y: 0.1111111111111111,
            w: 0.08910740740740741,
            charX: 0.02174259259259259
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.09969444444444443,
            y: 0.1111111111111111,
            w: 0.0895,
            charX: 0.021938888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08381111111111111,
            charX: 0.015
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.9009018518518519,
            y: 0,
            w: 0.09909814814814816,
            charX: 0.02347592592592592
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.8297499999999999,
            y: 0,
            w: 0.0925,
            charX: 0.023438888888888884
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.7603611111111112,
            y: 0,
            w: 0.08925555555555556,
            charX: 0.021816666666666665
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.6891833333333334,
            y: 0,
            w: 0.09043333333333334,
            charX: 0.022405555555555554
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.6151166666666666,
            y: 0,
            w: 0.09090000000000001,
            charX: 0.02263888888888889
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.5327500000000001,
            y: 0,
            w: 0.08916666666666667,
            charX: 0.02177222222222222
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'Y',
          width: 0.05431111111111111,
          isWordFirst: false,
          isWordLast: false,
          color: 1
        },
        char: 'Y',
        frames: [
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5381555555555555,
            y: 0,
            w: 0.0696,
            charX: 0.007644444444444443
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.4645574074074074,
            y: 0,
            w: 0.07061851851851851,
            charX: 0.008153703703703701
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.3889944444444444,
            y: 0,
            w: 0.07015185185185184,
            charX: 0.007920370370370366
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.31463148148148146,
            y: 0,
            w: 0.07075185185185184,
            charX: 0.008220370370370367
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.26911296296296294,
            y: 0,
            w: 0.06779629629629629,
            charX: 0.006742592592592588
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.18919444444444444,
            y: 0,
            w: 0.06818888888888888,
            charX: 0.006938888888888887
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.08381111111111111,
            y: 0,
            w: 0.07068888888888888,
            charX: 0.008188888888888888
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.07769999999999999,
            charX: 0.015
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9222499999999999,
            y: 0.1111111111111111,
            w: 0.07774999999999999,
            charX: 0.008438888888888883
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8496166666666667,
            y: 0.1111111111111111,
            w: 0.06794444444444443,
            charX: 0.006816666666666662
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7796166666666667,
            y: 0.1111111111111111,
            w: 0.06912222222222221,
            charX: 0.007405555555555551
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7060166666666666,
            y: 0.1111111111111111,
            w: 0.06958888888888888,
            charX: 0.007638888888888886
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6219166666666667,
            y: 0.1111111111111111,
            w: 0.06785555555555554,
            charX: 0.006772222222222218
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5381555555555555,
            y: 0.1111111111111111,
            w: 0.0696,
            charX: 0.007644444444444443
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.4645574074074074,
            y: 0.1111111111111111,
            w: 0.07061851851851851,
            charX: 0.008153703703703701
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.3889944444444444,
            y: 0.1111111111111111,
            w: 0.07015185185185184,
            charX: 0.007920370370370366
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.31463148148148146,
            y: 0.1111111111111111,
            w: 0.07075185185185184,
            charX: 0.008220370370370367
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.26911296296296294,
            y: 0.1111111111111111,
            w: 0.06779629629629629,
            charX: 0.006742592592592588
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.18919444444444444,
            y: 0.1111111111111111,
            w: 0.06818888888888888,
            charX: 0.006938888888888887
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.08381111111111111,
            y: 0.1111111111111111,
            w: 0.07068888888888888,
            charX: 0.008188888888888888
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.07769999999999999,
            charX: 0.015
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9222499999999999,
            y: 0,
            w: 0.07774999999999999,
            charX: 0.008438888888888883
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8496166666666667,
            y: 0,
            w: 0.06794444444444443,
            charX: 0.006816666666666662
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7796166666666667,
            y: 0,
            w: 0.06912222222222221,
            charX: 0.007405555555555551
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7060166666666666,
            y: 0,
            w: 0.06958888888888888,
            charX: 0.007638888888888886
          },
          {
            bit: {
              char: 'Y',
              width: 0.05431111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6219166666666667,
            y: 0,
            w: 0.06785555555555554,
            charX: 0.006772222222222218
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'S',
          width: 0.06062222222222223,
          isWordFirst: false,
          isWordLast: false,
          color: 1
        },
        char: 'S',
        frames: [
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6077555555555555,
            y: 0,
            w: 0.07591111111111111,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5351759259259259,
            y: 0,
            w: 0.07692962962962964,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.4591462962962963,
            y: 0,
            w: 0.07646296296296297,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.3853833333333333,
            y: 0,
            w: 0.07706296296296296,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.33690925925925924,
            y: 0,
            w: 0.07410740740740741,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.2573833333333333,
            y: 0,
            w: 0.0745,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.1545,
            y: 0,
            w: 0.077,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.07769999999999999,
            y: 0,
            w: 0.0774,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.08404814814814815,
            charX: 0.015
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9175611111111112,
            y: 0.1111111111111111,
            w: 0.0824388888888889,
            charX: 0.006816666666666663
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8487388888888889,
            y: 0.1111111111111111,
            w: 0.07543333333333334,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7756055555555555,
            y: 0.1111111111111111,
            w: 0.07590000000000001,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6897722222222222,
            y: 0.1111111111111111,
            w: 0.07416666666666667,
            charX: 0.006772222222222221
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6077555555555555,
            y: 0.1111111111111111,
            w: 0.07591111111111111,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5351759259259259,
            y: 0.1111111111111111,
            w: 0.07692962962962964,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.4591462962962963,
            y: 0.1111111111111111,
            w: 0.07646296296296297,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.3853833333333333,
            y: 0.1111111111111111,
            w: 0.07706296296296296,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.33690925925925924,
            y: 0.1111111111111111,
            w: 0.07410740740740741,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.2573833333333333,
            y: 0.1111111111111111,
            w: 0.0745,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.1545,
            y: 0.1111111111111111,
            w: 0.077,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.07769999999999999,
            y: 0.1111111111111111,
            w: 0.0774,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08404814814814815,
            charX: 0.015
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9175611111111112,
            y: 0,
            w: 0.0824388888888889,
            charX: 0.006816666666666663
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8487388888888889,
            y: 0,
            w: 0.07543333333333334,
            charX: 0.007405555555555554
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7756055555555555,
            y: 0,
            w: 0.07590000000000001,
            charX: 0.0076388888888888895
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6897722222222222,
            y: 0,
            w: 0.07416666666666667,
            charX: 0.006772222222222221
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'T',
          width: 0.053422222222222225,
          isWordFirst: false,
          isWordLast: false,
          color: 1
        },
        char: 'T',
        frames: [
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6836666666666666,
            y: 0,
            w: 0.06871111111111111,
            charX: 0.007644444444444443
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6121055555555556,
            y: 0,
            w: 0.06972962962962963,
            charX: 0.008153703703703701
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5356092592592593,
            y: 0,
            w: 0.06926296296296296,
            charX: 0.007920370370370366
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.46244629629629624,
            y: 0,
            w: 0.06986296296296296,
            charX: 0.008220370370370367
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.41101666666666664,
            y: 0,
            w: 0.0669074074074074,
            charX: 0.006742592592592588
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.3318833333333333,
            y: 0,
            w: 0.0673,
            charX: 0.006938888888888887
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.23149999999999998,
            y: 0,
            w: 0.0698,
            charX: 0.008188888888888888
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.1551,
            y: 0,
            w: 0.0702,
            charX: 0.008388888888888887
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.08404814814814815,
            y: 0,
            w: 0.07027407407407407,
            charX: 0.008425925925925924
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.07847037037037036,
            charX: 0.015
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9241722222222223,
            y: 0.1111111111111111,
            w: 0.07582777777777777,
            charX: 0.0074055555555555515
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8515055555555555,
            y: 0.1111111111111111,
            w: 0.0687,
            charX: 0.007638888888888886
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.763938888888889,
            y: 0.1111111111111111,
            w: 0.06696666666666666,
            charX: 0.006772222222222218
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6836666666666666,
            y: 0.1111111111111111,
            w: 0.06871111111111111,
            charX: 0.007644444444444443
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6121055555555556,
            y: 0.1111111111111111,
            w: 0.06972962962962963,
            charX: 0.008153703703703701
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5356092592592593,
            y: 0.1111111111111111,
            w: 0.06926296296296296,
            charX: 0.007920370370370366
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.46244629629629624,
            y: 0.1111111111111111,
            w: 0.06986296296296296,
            charX: 0.008220370370370367
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.41101666666666664,
            y: 0.1111111111111111,
            w: 0.0669074074074074,
            charX: 0.006742592592592588
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.3318833333333333,
            y: 0.1111111111111111,
            w: 0.0673,
            charX: 0.006938888888888887
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.23149999999999998,
            y: 0.1111111111111111,
            w: 0.0698,
            charX: 0.008188888888888888
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.1551,
            y: 0.1111111111111111,
            w: 0.0702,
            charX: 0.008388888888888887
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.08404814814814815,
            y: 0.1111111111111111,
            w: 0.07027407407407407,
            charX: 0.008425925925925924
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.07847037037037036,
            charX: 0.015
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9241722222222223,
            y: 0,
            w: 0.07582777777777777,
            charX: 0.0074055555555555515
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8515055555555555,
            y: 0,
            w: 0.0687,
            charX: 0.007638888888888886
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.763938888888889,
            y: 0,
            w: 0.06696666666666666,
            charX: 0.006772222222222218
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'E',
          width: 0.05715555555555556,
          isWordFirst: false,
          isWordLast: false,
          color: 1
        },
        char: 'E',
        frames: [
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7523777777777778,
            y: 0,
            w: 0.07244444444444444,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6818351851851852,
            y: 0,
            w: 0.07346296296296297,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6048722222222223,
            y: 0,
            w: 0.0729962962962963,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5323092592592592,
            y: 0,
            w: 0.07359629629629628,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.47792407407407406,
            y: 0,
            w: 0.07064074074074074,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.39918333333333333,
            y: 0,
            w: 0.07103333333333332,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.3013,
            y: 0,
            w: 0.07353333333333333,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.2253,
            y: 0,
            w: 0.07393333333333332,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.15432222222222222,
            y: 0,
            w: 0.07400740740740741,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.07847037037037036,
            y: 0,
            w: 0.07725185185185185,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.0816148148148148,
            charX: 0.015
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9202055555555555,
            y: 0.1111111111111111,
            w: 0.07979444444444445,
            charX: 0.007638888888888887
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8309055555555556,
            y: 0.1111111111111111,
            w: 0.0707,
            charX: 0.006772222222222221
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7523777777777778,
            y: 0.1111111111111111,
            w: 0.07244444444444444,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6818351851851852,
            y: 0.1111111111111111,
            w: 0.07346296296296297,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6048722222222223,
            y: 0.1111111111111111,
            w: 0.0729962962962963,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5323092592592592,
            y: 0.1111111111111111,
            w: 0.07359629629629628,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.47792407407407406,
            y: 0.1111111111111111,
            w: 0.07064074074074074,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.39918333333333333,
            y: 0.1111111111111111,
            w: 0.07103333333333332,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.3013,
            y: 0.1111111111111111,
            w: 0.07353333333333333,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.2253,
            y: 0.1111111111111111,
            w: 0.07393333333333332,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.15432222222222222,
            y: 0.1111111111111111,
            w: 0.07400740740740741,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.07847037037037036,
            y: 0.1111111111111111,
            w: 0.07725185185185185,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.0816148148148148,
            charX: 0.015
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9202055555555555,
            y: 0,
            w: 0.07979444444444445,
            charX: 0.007638888888888887
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8309055555555556,
            y: 0,
            w: 0.0707,
            charX: 0.006772222222222221
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'M',
          width: 0.07662222222222223,
          isWordFirst: false,
          isWordLast: false,
          color: 1
        },
        char: 'M',
        frames: [
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8248222222222222,
            y: 0,
            w: 0.09191111111111111,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7552981481481481,
            y: 0,
            w: 0.09292962962962964,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6778685185185186,
            y: 0,
            w: 0.09246296296296297,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6059055555555555,
            y: 0,
            w: 0.09306296296296296,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5485648148148148,
            y: 0,
            w: 0.09010740740740741,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.47021666666666667,
            y: 0,
            w: 0.0905,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.37483333333333335,
            y: 0,
            w: 0.093,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.29923333333333335,
            y: 0,
            w: 0.09340000000000001,
            charX: 0.00838888888888889
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.22832962962962963,
            y: 0,
            w: 0.09347407407407408,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.1557222222222222,
            y: 0,
            w: 0.09671851851851852,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.0816148148148148,
            y: 0,
            w: 0.09554074074074075,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.10084814814814815,
            charX: 0.015
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9016055555555555,
            y: 0.1111111111111111,
            w: 0.09839444444444445,
            charX: 0.0067722222222222185
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8248222222222222,
            y: 0.1111111111111111,
            w: 0.09191111111111111,
            charX: 0.00764444444444444
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.7552981481481481,
            y: 0.1111111111111111,
            w: 0.09292962962962964,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6778685185185186,
            y: 0.1111111111111111,
            w: 0.09246296296296297,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.6059055555555555,
            y: 0.1111111111111111,
            w: 0.09306296296296296,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5485648148148148,
            y: 0.1111111111111111,
            w: 0.09010740740740741,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.47021666666666667,
            y: 0.1111111111111111,
            w: 0.0905,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.37483333333333335,
            y: 0.1111111111111111,
            w: 0.093,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.29923333333333335,
            y: 0.1111111111111111,
            w: 0.09340000000000001,
            charX: 0.00838888888888889
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.22832962962962963,
            y: 0.1111111111111111,
            w: 0.09347407407407408,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.1557222222222222,
            y: 0.1111111111111111,
            w: 0.09671851851851852,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.0816148148148148,
            y: 0.1111111111111111,
            w: 0.09554074074074075,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.10084814814814815,
            charX: 0.015
          },
          {
            bit: {
              char: 'M',
              width: 0.07662222222222223,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.9016055555555555,
            y: 0,
            w: 0.09839444444444445,
            charX: 0.0067722222222222185
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'S',
          width: 0.06062222222222223,
          isWordFirst: false,
          isWordLast: true,
          color: 1
        },
        char: 'S',
        frames: [
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.9167333333333334,
            y: 0,
            w: 0.08326666666666667,
            charX: 0.007644444444444441
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.8482277777777778,
            y: 0,
            w: 0.09192962962962964,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.7703314814814816,
            y: 0,
            w: 0.09146296296296297,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.6989685185185184,
            y: 0,
            w: 0.09206296296296296,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.6386722222222222,
            y: 0,
            w: 0.08910740740740741,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.5607166666666666,
            y: 0,
            w: 0.0895,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.4678333333333333,
            y: 0,
            w: 0.092,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.3926333333333334,
            y: 0,
            w: 0.0924,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.3218037037037037,
            y: 0,
            w: 0.09247407407407408,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.25244074074074074,
            y: 0,
            w: 0.09571851851851852,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.17715555555555557,
            y: 0,
            w: 0.09454074074074074,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.10084814814814815,
            y: 0,
            w: 0.09407407407407407,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.10071481481481481,
            charX: 0.015
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.9167333333333334,
            y: 0.1111111111111111,
            w: 0.08326666666666667,
            charX: 0.007644444444444441
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.8482277777777778,
            y: 0.1111111111111111,
            w: 0.09192962962962964,
            charX: 0.008153703703703705
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.7703314814814816,
            y: 0.1111111111111111,
            w: 0.09146296296296297,
            charX: 0.00792037037037037
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.6989685185185184,
            y: 0.1111111111111111,
            w: 0.09206296296296296,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.6386722222222222,
            y: 0.1111111111111111,
            w: 0.08910740740740741,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.5607166666666666,
            y: 0.1111111111111111,
            w: 0.0895,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.4678333333333333,
            y: 0.1111111111111111,
            w: 0.092,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.3926333333333334,
            y: 0.1111111111111111,
            w: 0.0924,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.3218037037037037,
            y: 0.1111111111111111,
            w: 0.09247407407407408,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.25244074074074074,
            y: 0.1111111111111111,
            w: 0.09571851851851852,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.17715555555555557,
            y: 0.1111111111111111,
            w: 0.09454074074074074,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.10084814814814815,
            y: 0.1111111111111111,
            w: 0.09407407407407407,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'S',
              width: 0.06062222222222223,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.10071481481481481,
            charX: 0.015
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'I',
          width: 0.02168888888888889,
          isWordFirst: true,
          isWordLast: false,
          color: 2
        },
        char: 'I',
        frames: [
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.04840925925925926,
            charX: 0.015
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.9401574074074075,
            y: 0,
            w: 0.05984259259259259,
            charX: 0.023153703703703704
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.8617944444444445,
            y: 0,
            w: 0.05252962962962962,
            charX: 0.022920370370370365
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.7910314814814814,
            y: 0,
            w: 0.053129629629629624,
            charX: 0.023220370370370367
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.7277796296296296,
            y: 0,
            w: 0.050174074074074065,
            charX: 0.021742592592592588
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.6502166666666667,
            y: 0,
            w: 0.05056666666666666,
            charX: 0.021938888888888886
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.5598333333333333,
            y: 0,
            w: 0.053066666666666665,
            charX: 0.023188888888888887
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.48503333333333337,
            y: 0,
            w: 0.05346666666666666,
            charX: 0.023388888888888886
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.4142777777777778,
            y: 0,
            w: 0.053540740740740736,
            charX: 0.023425925925925923
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.3481592592592593,
            y: 0,
            w: 0.056785185185185175,
            charX: 0.025048148148148142
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.2716962962962963,
            y: 0,
            w: 0.0556074074074074,
            charX: 0.024459259259259254
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.19492222222222222,
            y: 0,
            w: 0.055140740740740726,
            charX: 0.024225925925925918
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.10071481481481481,
            y: 0,
            w: 0.05687407407407406,
            charX: 0.025092592592592586
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.04840925925925926,
            charX: 0.015
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.9401574074074075,
            y: 0.1111111111111111,
            w: 0.05984259259259259,
            charX: 0.023153703703703704
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.8617944444444445,
            y: 0.1111111111111111,
            w: 0.05252962962962962,
            charX: 0.022920370370370365
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.7910314814814814,
            y: 0.1111111111111111,
            w: 0.053129629629629624,
            charX: 0.023220370370370367
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.7277796296296296,
            y: 0.1111111111111111,
            w: 0.050174074074074065,
            charX: 0.021742592592592588
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.6502166666666667,
            y: 0.1111111111111111,
            w: 0.05056666666666666,
            charX: 0.021938888888888886
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.5598333333333333,
            y: 0.1111111111111111,
            w: 0.053066666666666665,
            charX: 0.023188888888888887
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.48503333333333337,
            y: 0.1111111111111111,
            w: 0.05346666666666666,
            charX: 0.023388888888888886
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.4142777777777778,
            y: 0.1111111111111111,
            w: 0.053540740740740736,
            charX: 0.023425925925925923
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.3481592592592593,
            y: 0.1111111111111111,
            w: 0.056785185185185175,
            charX: 0.025048148148148142
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.2716962962962963,
            y: 0.1111111111111111,
            w: 0.0556074074074074,
            charX: 0.024459259259259254
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.19492222222222222,
            y: 0.1111111111111111,
            w: 0.055140740740740726,
            charX: 0.024225925925925918
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.10071481481481481,
            y: 0.1111111111111111,
            w: 0.05687407407407406,
            charX: 0.025092592592592586
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'N',
          width: 0.06275555555555555,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'N',
        frames: [
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.04840925925925926,
            y: 0.1111111111111111,
            w: 0.0861962962962963,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08646666666666666,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9143240740740741,
            y: 0,
            w: 0.08567592592592592,
            charX: 0.007920370370370368
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.844161111111111,
            y: 0,
            w: 0.07919629629629628,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7779537037037036,
            y: 0,
            w: 0.07624074074074073,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7007833333333333,
            y: 0,
            w: 0.07663333333333332,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6129,
            y: 0,
            w: 0.07913333333333332,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5385,
            y: 0,
            w: 0.07953333333333332,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4678185185185185,
            y: 0,
            w: 0.0796074074074074,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.40494444444444444,
            y: 0,
            w: 0.08285185185185184,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3273037037037037,
            y: 0,
            w: 0.08167407407407407,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.25006296296296293,
            y: 0,
            w: 0.0812074074074074,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1575888888888889,
            y: 0,
            w: 0.08294074074074073,
            charX: 0.01009259259259259
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.04840925925925926,
            y: 0,
            w: 0.0861962962962963,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.08646666666666666,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9143240740740741,
            y: 0.1111111111111111,
            w: 0.08567592592592592,
            charX: 0.007920370370370368
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.844161111111111,
            y: 0.1111111111111111,
            w: 0.07919629629629628,
            charX: 0.008220370370370364
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7779537037037036,
            y: 0.1111111111111111,
            w: 0.07624074074074073,
            charX: 0.006742592592592592
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7007833333333333,
            y: 0.1111111111111111,
            w: 0.07663333333333332,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6129,
            y: 0.1111111111111111,
            w: 0.07913333333333332,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5385,
            y: 0.1111111111111111,
            w: 0.07953333333333332,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4678185185185185,
            y: 0.1111111111111111,
            w: 0.0796074074074074,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.40494444444444444,
            y: 0.1111111111111111,
            w: 0.08285185185185184,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3273037037037037,
            y: 0.1111111111111111,
            w: 0.08167407407407407,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.25006296296296293,
            y: 0.1111111111111111,
            w: 0.0812074074074074,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1575888888888889,
            y: 0.1111111111111111,
            w: 0.08294074074074073,
            charX: 0.01009259259259259
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'T',
          width: 0.053422222222222225,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'T',
        frames: [
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.13460555555555556,
            y: 0.1111111111111111,
            w: 0.07686296296296297,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08646666666666666,
            y: 0.1111111111111111,
            w: 0.07084444444444445,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.07736666666666667,
            charX: 0.015
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9233574074074073,
            y: 0,
            w: 0.0766425925925926,
            charX: 0.008220370370370366
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8541944444444444,
            y: 0,
            w: 0.0669074074074074,
            charX: 0.006742592592592588
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7774166666666666,
            y: 0,
            w: 0.0673,
            charX: 0.006938888888888887
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6920333333333333,
            y: 0,
            w: 0.0698,
            charX: 0.008188888888888888
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6180333333333333,
            y: 0,
            w: 0.0702,
            charX: 0.008388888888888887
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.547425925925926,
            y: 0,
            w: 0.07027407407407407,
            charX: 0.008425925925925924
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4877962962962963,
            y: 0,
            w: 0.07351851851851851,
            charX: 0.010048148148148143
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4089777777777778,
            y: 0,
            w: 0.07234074074074073,
            charX: 0.009459259259259254
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3312703703703703,
            y: 0,
            w: 0.07187407407407406,
            charX: 0.009225925925925919
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.24052962962962962,
            y: 0,
            w: 0.0736074074074074,
            charX: 0.010092592592592587
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.13460555555555556,
            y: 0,
            w: 0.07686296296296297,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08646666666666666,
            y: 0,
            w: 0.07084444444444445,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.07736666666666667,
            charX: 0.015
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9233574074074073,
            y: 0.1111111111111111,
            w: 0.0766425925925926,
            charX: 0.008220370370370366
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8541944444444444,
            y: 0.1111111111111111,
            w: 0.0669074074074074,
            charX: 0.006742592592592588
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7774166666666666,
            y: 0.1111111111111111,
            w: 0.0673,
            charX: 0.006938888888888887
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6920333333333333,
            y: 0.1111111111111111,
            w: 0.0698,
            charX: 0.008188888888888888
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6180333333333333,
            y: 0.1111111111111111,
            w: 0.0702,
            charX: 0.008388888888888887
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.547425925925926,
            y: 0.1111111111111111,
            w: 0.07027407407407407,
            charX: 0.008425925925925924
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4877962962962963,
            y: 0.1111111111111111,
            w: 0.07351851851851851,
            charX: 0.010048148148148143
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4089777777777778,
            y: 0.1111111111111111,
            w: 0.07234074074074073,
            charX: 0.009459259259259254
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3312703703703703,
            y: 0.1111111111111111,
            w: 0.07187407407407406,
            charX: 0.009225925925925919
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.24052962962962962,
            y: 0.1111111111111111,
            w: 0.0736074074074074,
            charX: 0.010092592592592587
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'E',
          width: 0.05715555555555556,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'E',
        frames: [
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.21146851851851853,
            y: 0.1111111111111111,
            w: 0.0805962962962963,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.15731111111111112,
            y: 0.1111111111111111,
            w: 0.07457777777777777,
            charX: 0.008711111111111107
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.07736666666666667,
            y: 0.1111111111111111,
            w: 0.07504444444444444,
            charX: 0.008944444444444442
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.0808,
            charX: 0.015
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9211018518518518,
            y: 0,
            w: 0.07889814814814815,
            charX: 0.006742592592592589
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8447166666666667,
            y: 0,
            w: 0.07103333333333332,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7618333333333333,
            y: 0,
            w: 0.07353333333333333,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6882333333333334,
            y: 0,
            w: 0.07393333333333332,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6177,
            y: 0,
            w: 0.07400740740740741,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5613148148148148,
            y: 0,
            w: 0.07725185185185185,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4813185185185185,
            y: 0,
            w: 0.07607407407407407,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4031444444444444,
            y: 0,
            w: 0.0756074074074074,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.314137037037037,
            y: 0,
            w: 0.07734074074074074,
            charX: 0.01009259259259259
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.21146851851851853,
            y: 0,
            w: 0.0805962962962963,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.15731111111111112,
            y: 0,
            w: 0.07457777777777777,
            charX: 0.008711111111111107
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.07736666666666667,
            y: 0,
            w: 0.07504444444444444,
            charX: 0.008944444444444442
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.0808,
            charX: 0.015
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9211018518518518,
            y: 0.1111111111111111,
            w: 0.07889814814814815,
            charX: 0.006742592592592589
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8447166666666667,
            y: 0.1111111111111111,
            w: 0.07103333333333332,
            charX: 0.006938888888888883
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7618333333333333,
            y: 0.1111111111111111,
            w: 0.07353333333333333,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6882333333333334,
            y: 0.1111111111111111,
            w: 0.07393333333333332,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6177,
            y: 0.1111111111111111,
            w: 0.07400740740740741,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5613148148148148,
            y: 0.1111111111111111,
            w: 0.07725185185185185,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4813185185185185,
            y: 0.1111111111111111,
            w: 0.07607407407407407,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4031444444444444,
            y: 0.1111111111111111,
            w: 0.0756074074074074,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'E',
              width: 0.05715555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.314137037037037,
            y: 0.1111111111111111,
            w: 0.07734074074074074,
            charX: 0.01009259259259259
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'R',
          width: 0.06231111111111111,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'R',
        frames: [
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.29206481481481483,
            y: 0.1111111111111111,
            w: 0.08575185185185186,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2318888888888889,
            y: 0.1111111111111111,
            w: 0.07973333333333332,
            charX: 0.008711111111111107
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1524111111111111,
            y: 0.1111111111111111,
            w: 0.0802,
            charX: 0.008944444444444442
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.0808,
            y: 0.1111111111111111,
            w: 0.07959999999999999,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08743333333333332,
            charX: 0.015
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.91575,
            y: 0,
            w: 0.08424999999999999,
            charX: 0.006938888888888886
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8353666666666666,
            y: 0,
            w: 0.07868888888888888,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7621666666666667,
            y: 0,
            w: 0.07908888888888888,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6917074074074074,
            y: 0,
            w: 0.07916296296296296,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6385666666666667,
            y: 0,
            w: 0.0824074074074074,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5573925925925926,
            y: 0,
            w: 0.08122962962962962,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4787518518518518,
            y: 0,
            w: 0.08076296296296295,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3914777777777777,
            y: 0,
            w: 0.08249629629629629,
            charX: 0.01009259259259259
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.29206481481481483,
            y: 0,
            w: 0.08575185185185186,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2318888888888889,
            y: 0,
            w: 0.07973333333333332,
            charX: 0.008711111111111107
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1524111111111111,
            y: 0,
            w: 0.0802,
            charX: 0.008944444444444442
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.0808,
            y: 0,
            w: 0.07959999999999999,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.08743333333333332,
            charX: 0.015
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.91575,
            y: 0.1111111111111111,
            w: 0.08424999999999999,
            charX: 0.006938888888888886
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8353666666666666,
            y: 0.1111111111111111,
            w: 0.07868888888888888,
            charX: 0.008188888888888884
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7621666666666667,
            y: 0.1111111111111111,
            w: 0.07908888888888888,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6917074074074074,
            y: 0.1111111111111111,
            w: 0.07916296296296296,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6385666666666667,
            y: 0.1111111111111111,
            w: 0.0824074074074074,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5573925925925926,
            y: 0.1111111111111111,
            w: 0.08122962962962962,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4787518518518518,
            y: 0.1111111111111111,
            w: 0.08076296296296295,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'R',
              width: 0.06231111111111111,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3914777777777777,
            y: 0.1111111111111111,
            w: 0.08249629629629629,
            charX: 0.01009259259259259
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'N',
          width: 0.06275555555555555,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'N',
        frames: [
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3778166666666667,
            y: 0.1111111111111111,
            w: 0.0861962962962963,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.31162222222222224,
            y: 0.1111111111111111,
            w: 0.08017777777777776,
            charX: 0.008711111111111107
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2326111111111111,
            y: 0.1111111111111111,
            w: 0.08064444444444444,
            charX: 0.008944444444444442
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1604,
            y: 0.1111111111111111,
            w: 0.08004444444444443,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08743333333333332,
            y: 0.1111111111111111,
            w: 0.08299999999999999,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08768148148148147,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9140555555555555,
            y: 0,
            w: 0.08594444444444443,
            charX: 0.008188888888888886
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8412555555555555,
            y: 0,
            w: 0.07953333333333332,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7708703703703704,
            y: 0,
            w: 0.0796074074074074,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7209740740740741,
            y: 0,
            w: 0.08285185185185184,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6386222222222222,
            y: 0,
            w: 0.08167407407407407,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5595148148148148,
            y: 0,
            w: 0.0812074074074074,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.473974074074074,
            y: 0,
            w: 0.08294074074074073,
            charX: 0.01009259259259259
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3778166666666667,
            y: 0,
            w: 0.0861962962962963,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.31162222222222224,
            y: 0,
            w: 0.08017777777777776,
            charX: 0.008711111111111107
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2326111111111111,
            y: 0,
            w: 0.08064444444444444,
            charX: 0.008944444444444442
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1604,
            y: 0,
            w: 0.08004444444444443,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08743333333333332,
            y: 0,
            w: 0.08299999999999999,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.08768148148148147,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9140555555555555,
            y: 0.1111111111111111,
            w: 0.08594444444444443,
            charX: 0.008188888888888886
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8412555555555555,
            y: 0.1111111111111111,
            w: 0.07953333333333332,
            charX: 0.008388888888888883
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7708703703703704,
            y: 0.1111111111111111,
            w: 0.0796074074074074,
            charX: 0.008425925925925927
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7209740740740741,
            y: 0.1111111111111111,
            w: 0.08285185185185184,
            charX: 0.010048148148148146
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6386222222222222,
            y: 0.1111111111111111,
            w: 0.08167407407407407,
            charX: 0.009459259259259258
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5595148148148148,
            y: 0.1111111111111111,
            w: 0.0812074074074074,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.473974074074074,
            y: 0.1111111111111111,
            w: 0.08294074074074073,
            charX: 0.01009259259259259
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'A',
          width: 0.055822222222222224,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'A',
        frames: [
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.464012962962963,
            y: 0.1111111111111111,
            w: 0.07926296296296297,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.39180000000000004,
            y: 0.1111111111111111,
            w: 0.07324444444444445,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3132555555555555,
            y: 0.1111111111111111,
            w: 0.07371111111111112,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2404444444444444,
            y: 0.1111111111111111,
            w: 0.07311111111111111,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.17043333333333333,
            y: 0.1111111111111111,
            w: 0.07606666666666666,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08768148148148147,
            y: 0.1111111111111111,
            w: 0.07567407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08074814814814815,
            charX: 0.015
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9207888888888889,
            y: 0,
            w: 0.07921111111111111,
            charX: 0.008388888888888887
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8504777777777779,
            y: 0,
            w: 0.07267407407407407,
            charX: 0.008425925925925924
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8038259259259259,
            y: 0,
            w: 0.07591851851851851,
            charX: 0.010048148148148143
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7202962962962962,
            y: 0,
            w: 0.07474074074074073,
            charX: 0.009459259259259254
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6407222222222222,
            y: 0,
            w: 0.07427407407407406,
            charX: 0.009225925925925919
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5569148148148148,
            y: 0,
            w: 0.0760074074074074,
            charX: 0.010092592592592587
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.464012962962963,
            y: 0,
            w: 0.07926296296296297,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.39180000000000004,
            y: 0,
            w: 0.07324444444444445,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3132555555555555,
            y: 0,
            w: 0.07371111111111112,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2404444444444444,
            y: 0,
            w: 0.07311111111111111,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.17043333333333333,
            y: 0,
            w: 0.07606666666666666,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08768148148148147,
            y: 0,
            w: 0.07567407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.08074814814814815,
            charX: 0.015
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9207888888888889,
            y: 0.1111111111111111,
            w: 0.07921111111111111,
            charX: 0.008388888888888887
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8504777777777779,
            y: 0.1111111111111111,
            w: 0.07267407407407407,
            charX: 0.008425925925925924
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8038259259259259,
            y: 0.1111111111111111,
            w: 0.07591851851851851,
            charX: 0.010048148148148143
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7202962962962962,
            y: 0.1111111111111111,
            w: 0.07474074074074073,
            charX: 0.009459259259259254
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6407222222222222,
            y: 0.1111111111111111,
            w: 0.07427407407407406,
            charX: 0.009225925925925919
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5569148148148148,
            y: 0.1111111111111111,
            w: 0.0760074074074074,
            charX: 0.010092592592592587
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'T',
          width: 0.053422222222222225,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'T',
        frames: [
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.543275925925926,
            y: 0.1111111111111111,
            w: 0.07686296296296297,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4650444444444445,
            y: 0.1111111111111111,
            w: 0.07084444444444445,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3869666666666666,
            y: 0.1111111111111111,
            w: 0.07131111111111112,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.31355555555555553,
            y: 0.1111111111111111,
            w: 0.07071111111111111,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2465,
            y: 0.1111111111111111,
            w: 0.07366666666666666,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.16335555555555553,
            y: 0.1111111111111111,
            w: 0.07327407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08074814814814815,
            y: 0.1111111111111111,
            w: 0.07327407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.07689814814814813,
            charX: 0.015
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.923151851851852,
            y: 0,
            w: 0.07684814814814815,
            charX: 0.008425925925925925
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8797444444444444,
            y: 0,
            w: 0.07351851851851851,
            charX: 0.010048148148148143
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.795037037037037,
            y: 0,
            w: 0.07234074074074073,
            charX: 0.009459259259259254
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7149962962962962,
            y: 0,
            w: 0.07187407407407406,
            charX: 0.009225925925925919
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6329222222222222,
            y: 0,
            w: 0.0736074074074074,
            charX: 0.010092592592592587
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.543275925925926,
            y: 0,
            w: 0.07686296296296297,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4650444444444445,
            y: 0,
            w: 0.07084444444444445,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3869666666666666,
            y: 0,
            w: 0.07131111111111112,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.31355555555555553,
            y: 0,
            w: 0.07071111111111111,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2465,
            y: 0,
            w: 0.07366666666666666,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.16335555555555553,
            y: 0,
            w: 0.07327407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08074814814814815,
            y: 0,
            w: 0.07327407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.07689814814814813,
            charX: 0.015
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.923151851851852,
            y: 0.1111111111111111,
            w: 0.07684814814814815,
            charX: 0.008425925925925925
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8797444444444444,
            y: 0.1111111111111111,
            w: 0.07351851851851851,
            charX: 0.010048148148148143
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.795037037037037,
            y: 0.1111111111111111,
            w: 0.07234074074074073,
            charX: 0.009459259259259254
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7149962962962962,
            y: 0.1111111111111111,
            w: 0.07187407407407406,
            charX: 0.009225925925925919
          },
          {
            bit: {
              char: 'T',
              width: 0.053422222222222225,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6329222222222222,
            y: 0.1111111111111111,
            w: 0.0736074074074074,
            charX: 0.010092592592592587
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'I',
          width: 0.02168888888888889,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'I',
        frames: [
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.620138888888889,
            y: 0.1111111111111111,
            w: 0.04512962962962963,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.535888888888889,
            y: 0.1111111111111111,
            w: 0.03911111111111111,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.45827777777777773,
            y: 0.1111111111111111,
            w: 0.03957777777777778,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.38426666666666665,
            y: 0.1111111111111111,
            w: 0.03897777777777778,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.32016666666666665,
            y: 0.1111111111111111,
            w: 0.04193333333333332,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2366296296296296,
            y: 0.1111111111111111,
            w: 0.04154074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.15402222222222223,
            y: 0.1111111111111111,
            w: 0.04154074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.07689814814814813,
            y: 0.1111111111111111,
            w: 0.03864074074074073,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.045127777777777774,
            charX: 0.015
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.953262962962963,
            y: 0,
            w: 0.046737037037037035,
            charX: 0.010048148148148145
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8673777777777777,
            y: 0,
            w: 0.0406074074074074,
            charX: 0.009459259259259254
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7868703703703703,
            y: 0,
            w: 0.04014074074074073,
            charX: 0.009225925925925919
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7065296296296295,
            y: 0,
            w: 0.041874074074074064,
            charX: 0.010092592592592587
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.620138888888889,
            y: 0,
            w: 0.04512962962962963,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.535888888888889,
            y: 0,
            w: 0.03911111111111111,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.45827777777777773,
            y: 0,
            w: 0.03957777777777778,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.38426666666666665,
            y: 0,
            w: 0.03897777777777778,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.32016666666666665,
            y: 0,
            w: 0.04193333333333332,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2366296296296296,
            y: 0,
            w: 0.04154074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.15402222222222223,
            y: 0,
            w: 0.04154074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.07689814814814813,
            y: 0,
            w: 0.03864074074074073,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.045127777777777774,
            charX: 0.015
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.953262962962963,
            y: 0.1111111111111111,
            w: 0.046737037037037035,
            charX: 0.010048148148148145
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8673777777777777,
            y: 0.1111111111111111,
            w: 0.0406074074074074,
            charX: 0.009459259259259254
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7868703703703703,
            y: 0.1111111111111111,
            w: 0.04014074074074073,
            charX: 0.009225925925925919
          },
          {
            bit: {
              char: 'I',
              width: 0.02168888888888889,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7065296296296295,
            y: 0.1111111111111111,
            w: 0.041874074074074064,
            charX: 0.010092592592592587
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'O',
          width: 0.06755555555555556,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'O',
        frames: [
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6652685185185186,
            y: 0.1111111111111111,
            w: 0.09099629629629631,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5750000000000001,
            y: 0.1111111111111111,
            w: 0.08497777777777779,
            charX: 0.008711111111111114
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4978555555555555,
            y: 0.1111111111111111,
            w: 0.08544444444444446,
            charX: 0.00894444444444445
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4232444444444444,
            y: 0.1111111111111111,
            w: 0.08484444444444444,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3621,
            y: 0.1111111111111111,
            w: 0.0878,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.27817037037037035,
            y: 0.1111111111111111,
            w: 0.0874074074074074,
            charX: 0.009925925925925921
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.19556296296296297,
            y: 0.1111111111111111,
            w: 0.08740740740740742,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.11553888888888886,
            y: 0.1111111111111111,
            w: 0.0845074074074074,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.045127777777777774,
            y: 0.1111111111111111,
            w: 0.08443333333333333,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08937222222222223,
            charX: 0.015
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9079851851851851,
            y: 0,
            w: 0.09201481481481481,
            charX: 0.009459259259259256
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.827011111111111,
            y: 0,
            w: 0.08600740740740741,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7484037037037036,
            y: 0,
            w: 0.08774074074074074,
            charX: 0.01009259259259259
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6652685185185186,
            y: 0,
            w: 0.09099629629629631,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5750000000000001,
            y: 0,
            w: 0.08497777777777779,
            charX: 0.008711111111111114
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4978555555555555,
            y: 0,
            w: 0.08544444444444446,
            charX: 0.00894444444444445
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4232444444444444,
            y: 0,
            w: 0.08484444444444444,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3621,
            y: 0,
            w: 0.0878,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.27817037037037035,
            y: 0,
            w: 0.0874074074074074,
            charX: 0.009925925925925921
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.19556296296296297,
            y: 0,
            w: 0.08740740740740742,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.11553888888888886,
            y: 0,
            w: 0.0845074074074074,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.045127777777777774,
            y: 0,
            w: 0.08443333333333333,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.08937222222222223,
            charX: 0.015
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9079851851851851,
            y: 0.1111111111111111,
            w: 0.09201481481481481,
            charX: 0.009459259259259256
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.827011111111111,
            y: 0.1111111111111111,
            w: 0.08600740740740741,
            charX: 0.009225925925925922
          },
          {
            bit: {
              char: 'O',
              width: 0.06755555555555556,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7484037037037036,
            y: 0.1111111111111111,
            w: 0.08774074074074074,
            charX: 0.01009259259259259
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'N',
          width: 0.06275555555555555,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'N',
        frames: [
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.756264814814815,
            y: 0.1111111111111111,
            w: 0.0861962962962963,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6599777777777779,
            y: 0.1111111111111111,
            w: 0.08017777777777776,
            charX: 0.008711111111111107
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5832999999999999,
            y: 0.1111111111111111,
            w: 0.08064444444444444,
            charX: 0.008944444444444442
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5080888888888888,
            y: 0.1111111111111111,
            w: 0.08004444444444443,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.44989999999999997,
            y: 0.1111111111111111,
            w: 0.08299999999999999,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3655777777777778,
            y: 0.1111111111111111,
            w: 0.0826074074074074,
            charX: 0.009925925925925921
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.28297037037037037,
            y: 0.1111111111111111,
            w: 0.08260740740740741,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.20004629629629628,
            y: 0.1111111111111111,
            w: 0.0797074074074074,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1295611111111111,
            y: 0.1111111111111111,
            w: 0.07963333333333332,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08937222222222223,
            y: 0.1111111111111111,
            w: 0.07638888888888888,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.0851611111111111,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9130185185185185,
            y: 0,
            w: 0.08698148148148147,
            charX: 0.00922592592592592
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8361444444444444,
            y: 0,
            w: 0.08294074074074073,
            charX: 0.01009259259259259
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.756264814814815,
            y: 0,
            w: 0.0861962962962963,
            charX: 0.011720370370370374
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6599777777777779,
            y: 0,
            w: 0.08017777777777776,
            charX: 0.008711111111111107
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5832999999999999,
            y: 0,
            w: 0.08064444444444444,
            charX: 0.008944444444444442
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5080888888888888,
            y: 0,
            w: 0.08004444444444443,
            charX: 0.00864444444444444
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.44989999999999997,
            y: 0,
            w: 0.08299999999999999,
            charX: 0.01012222222222222
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3655777777777778,
            y: 0,
            w: 0.0826074074074074,
            charX: 0.009925925925925921
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.28297037037037037,
            y: 0,
            w: 0.08260740740740741,
            charX: 0.009925925925925928
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.20004629629629628,
            y: 0,
            w: 0.0797074074074074,
            charX: 0.008475925925925921
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1295611111111111,
            y: 0,
            w: 0.07963333333333332,
            charX: 0.008438888888888885
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.08937222222222223,
            y: 0,
            w: 0.07638888888888888,
            charX: 0.006816666666666665
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.0851611111111111,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9130185185185185,
            y: 0.1111111111111111,
            w: 0.08698148148148147,
            charX: 0.00922592592592592
          },
          {
            bit: {
              char: 'N',
              width: 0.06275555555555555,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8361444444444444,
            y: 0.1111111111111111,
            w: 0.08294074074074073,
            charX: 0.01009259259259259
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'A',
          width: 0.055822222222222224,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'A',
        frames: [
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8424611111111113,
            y: 0.1111111111111111,
            w: 0.07926296296296297,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7401555555555557,
            y: 0.1111111111111111,
            w: 0.07324444444444445,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6639444444444443,
            y: 0.1111111111111111,
            w: 0.07371111111111112,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5881333333333333,
            y: 0.1111111111111111,
            w: 0.07311111111111111,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5328999999999999,
            y: 0.1111111111111111,
            w: 0.07606666666666666,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4481851851851852,
            y: 0.1111111111111111,
            w: 0.07567407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3655777777777778,
            y: 0.1111111111111111,
            w: 0.07567407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.27975370370370367,
            y: 0.1111111111111111,
            w: 0.07277407407407407,
            charX: 0.008475925925925925
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2091944444444444,
            y: 0.1111111111111111,
            w: 0.07269999999999999,
            charX: 0.008438888888888881
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1657611111111111,
            y: 0.1111111111111111,
            w: 0.06945555555555555,
            charX: 0.006816666666666662
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.0851611111111111,
            y: 0.1111111111111111,
            w: 0.07063333333333333,
            charX: 0.007405555555555551
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.07846111111111112,
            charX: 0.015
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9190851851851851,
            y: 0,
            w: 0.08091481481481481,
            charX: 0.010092592592592589
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8424611111111113,
            y: 0,
            w: 0.07926296296296297,
            charX: 0.01172037037037037
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.7401555555555557,
            y: 0,
            w: 0.07324444444444445,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6639444444444443,
            y: 0,
            w: 0.07371111111111112,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5881333333333333,
            y: 0,
            w: 0.07311111111111111,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5328999999999999,
            y: 0,
            w: 0.07606666666666666,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.4481851851851852,
            y: 0,
            w: 0.07567407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3655777777777778,
            y: 0,
            w: 0.07567407407407407,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.27975370370370367,
            y: 0,
            w: 0.07277407407407407,
            charX: 0.008475925925925925
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.2091944444444444,
            y: 0,
            w: 0.07269999999999999,
            charX: 0.008438888888888881
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1657611111111111,
            y: 0,
            w: 0.06945555555555555,
            charX: 0.006816666666666662
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.0851611111111111,
            y: 0,
            w: 0.07063333333333333,
            charX: 0.007405555555555551
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.07846111111111112,
            charX: 0.015
          },
          {
            bit: {
              char: 'A',
              width: 0.055822222222222224,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.9190851851851851,
            y: 0.1111111111111111,
            w: 0.08091481481481481,
            charX: 0.010092592592592589
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'L',
          width: 0.051555555555555556,
          isWordFirst: false,
          isWordLast: true,
          color: 2
        },
        char: 'L',
        frames: [
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.9217240740740743,
            y: 0.1111111111111111,
            w: 0.07827592592592593,
            charX: 0.011720370370370372
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.8134000000000001,
            y: 0.1111111111111111,
            w: 0.08397777777777778,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.7376555555555555,
            y: 0.1111111111111111,
            w: 0.08444444444444445,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.6612444444444444,
            y: 0.1111111111111111,
            w: 0.08384444444444444,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.6089666666666665,
            y: 0.1111111111111111,
            w: 0.08679999999999999,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.5238592592592592,
            y: 0.1111111111111111,
            w: 0.0864074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.44125185185185184,
            y: 0.1111111111111111,
            w: 0.0864074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.3525277777777778,
            y: 0.1111111111111111,
            w: 0.0835074074074074,
            charX: 0.008475925925925925
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.2818944444444444,
            y: 0.1111111111111111,
            w: 0.08343333333333332,
            charX: 0.008438888888888881
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.23521666666666666,
            y: 0.1111111111111111,
            w: 0.08018888888888888,
            charX: 0.006816666666666662
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.15579444444444443,
            y: 0.1111111111111111,
            w: 0.08136666666666666,
            charX: 0.007405555555555551
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.07846111111111112,
            y: 0.1111111111111111,
            w: 0.08183333333333333,
            charX: 0.007638888888888886
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0,
            y: 0.1111111111111111,
            w: 0.08832777777777778,
            charX: 0.015
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.9217240740740743,
            y: 0,
            w: 0.07827592592592593,
            charX: 0.011720370370370372
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.8134000000000001,
            y: 0,
            w: 0.08397777777777778,
            charX: 0.00871111111111111
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.7376555555555555,
            y: 0,
            w: 0.08444444444444445,
            charX: 0.008944444444444446
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.6612444444444444,
            y: 0,
            w: 0.08384444444444444,
            charX: 0.008644444444444444
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.6089666666666665,
            y: 0,
            w: 0.08679999999999999,
            charX: 0.010122222222222216
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.5238592592592592,
            y: 0,
            w: 0.0864074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.44125185185185184,
            y: 0,
            w: 0.0864074074074074,
            charX: 0.009925925925925925
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.3525277777777778,
            y: 0,
            w: 0.0835074074074074,
            charX: 0.008475925925925925
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.2818944444444444,
            y: 0,
            w: 0.08343333333333332,
            charX: 0.008438888888888881
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.23521666666666666,
            y: 0,
            w: 0.08018888888888888,
            charX: 0.006816666666666662
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.15579444444444443,
            y: 0,
            w: 0.08136666666666666,
            charX: 0.007405555555555551
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.07846111111111112,
            y: 0,
            w: 0.08183333333333333,
            charX: 0.007638888888888886
          },
          {
            bit: {
              char: 'L',
              width: 0.051555555555555556,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.08832777777777778,
            charX: 0.015
          }
        ],
        color: 2
      }
    ]
  },
  notFound: {
    ratio: 2.5,
    width: 1,
    height: 0.4,
    rows: 2,
    cols: 6,
    words: ['PAGE', 'NOT', 'FOUND'],
    rowHeight: 0.2,
    fontSize: 0.16000000000000003,
    wordGap: 0.015,
    startGap: 0.015,
    endGap: 0.015,
    fontYOffset: 0.1592,
    numFrames: 12,
    chars: [
      {
        bit: {
          char: 'P',
          width: 0.10288000000000003,
          isWordFirst: true,
          isWordLast: false,
          color: 0
        },
        char: 'P',
        frames: [
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.145736,
            charX: 0.015
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.8395199999999999,
            y: 0.2,
            w: 0.16048,
            charX: 0.04259999999999998
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.684944,
            y: 0.2,
            w: 0.172344,
            charX: 0.04223199999999998
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.5093599999999999,
            y: 0.2,
            w: 0.17253599999999997,
            charX: 0.04232799999999998
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.343536,
            y: 0.2,
            w: 0.174904,
            charX: 0.04351199999999998
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.17055199999999998,
            y: 0.2,
            w: 0.168904,
            charX: 0.04051199999999998
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0.2,
            w: 0.145736,
            charX: 0.015
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.8395199999999999,
            y: 0,
            w: 0.16048,
            charX: 0.04259999999999998
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.684944,
            y: 0,
            w: 0.172344,
            charX: 0.04223199999999998
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.5093599999999999,
            y: 0,
            w: 0.17253599999999997,
            charX: 0.04232799999999998
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.343536,
            y: 0,
            w: 0.174904,
            charX: 0.04351199999999998
          },
          {
            bit: {
              char: 'P',
              width: 0.10288000000000003,
              isWordFirst: true,
              isWordLast: false,
              color: 0
            },
            x: 0.17055199999999998,
            y: 0,
            w: 0.168904,
            charX: 0.04051199999999998
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'A',
          width: 0.10048000000000001,
          isWordFirst: false,
          isWordLast: false,
          color: 0
        },
        char: 'A',
        frames: [
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.145736,
            y: 0,
            w: 0.15619199999999997,
            charX: 0.027855999999999978
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.144008,
            charX: 0.015
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.857288,
            y: 0.2,
            w: 0.142712,
            charX: 0.02723199999999998
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6818959999999998,
            y: 0.2,
            w: 0.15513599999999997,
            charX: 0.027327999999999977
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.51844,
            y: 0.2,
            w: 0.15750399999999998,
            charX: 0.028511999999999982
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.339456,
            y: 0.2,
            w: 0.15150399999999997,
            charX: 0.02551199999999998
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.145736,
            y: 0.2,
            w: 0.15619199999999997,
            charX: 0.027855999999999978
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0.2,
            w: 0.144008,
            charX: 0.015
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.857288,
            y: 0,
            w: 0.142712,
            charX: 0.02723199999999998
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.6818959999999998,
            y: 0,
            w: 0.15513599999999997,
            charX: 0.027327999999999977
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.51844,
            y: 0,
            w: 0.15750399999999998,
            charX: 0.028511999999999982
          },
          {
            bit: {
              char: 'A',
              width: 0.10048000000000001,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.339456,
            y: 0,
            w: 0.15150399999999997,
            charX: 0.02551199999999998
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'G',
          width: 0.12064000000000002,
          isWordFirst: false,
          isWordLast: false,
          color: 0
        },
        char: 'G',
        frames: [
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.301928,
            y: 0,
            w: 0.17635199999999998,
            charX: 0.027855999999999978
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.144008,
            y: 0,
            w: 0.177696,
            charX: 0.028527999999999984
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.16153600000000004,
            charX: 0.015
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.8370319999999998,
            y: 0.2,
            w: 0.162968,
            charX: 0.027327999999999974
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.675944,
            y: 0.2,
            w: 0.177664,
            charX: 0.028511999999999982
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.49095999999999995,
            y: 0.2,
            w: 0.17166399999999998,
            charX: 0.02551199999999998
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.301928,
            y: 0.2,
            w: 0.17635199999999998,
            charX: 0.027855999999999978
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.144008,
            y: 0.2,
            w: 0.177696,
            charX: 0.028527999999999984
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0,
            y: 0.2,
            w: 0.16153600000000004,
            charX: 0.015
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.8370319999999998,
            y: 0,
            w: 0.162968,
            charX: 0.027327999999999974
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.675944,
            y: 0,
            w: 0.177664,
            charX: 0.028511999999999982
          },
          {
            bit: {
              char: 'G',
              width: 0.12064000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 0
            },
            x: 0.49095999999999995,
            y: 0,
            w: 0.17166399999999998,
            charX: 0.02551199999999998
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'E',
          width: 0.10288000000000003,
          isWordFirst: false,
          isWordLast: true,
          color: 0
        },
        char: 'E',
        frames: [
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.4782799999999999,
            y: 0,
            w: 0.17359199999999997,
            charX: 0.027855999999999978
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.321704,
            y: 0,
            w: 0.17493599999999998,
            charX: 0.028527999999999984
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.16153600000000004,
            y: 0,
            w: 0.169672,
            charX: 0.02589599999999999
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0,
            y: 0,
            w: 0.15868,
            charX: 0.015
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.8536079999999999,
            y: 0.2,
            w: 0.14639200000000002,
            charX: 0.028511999999999982
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.6626239999999999,
            y: 0.2,
            w: 0.168904,
            charX: 0.02551199999999998
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.4782799999999999,
            y: 0.2,
            w: 0.17359199999999997,
            charX: 0.027855999999999978
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.321704,
            y: 0.2,
            w: 0.17493599999999998,
            charX: 0.028527999999999984
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.16153600000000004,
            y: 0.2,
            w: 0.169672,
            charX: 0.02589599999999999
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0,
            y: 0.2,
            w: 0.15868,
            charX: 0.015
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.8536079999999999,
            y: 0,
            w: 0.14639200000000002,
            charX: 0.028511999999999982
          },
          {
            bit: {
              char: 'E',
              width: 0.10288000000000003,
              isWordFirst: false,
              isWordLast: true,
              color: 0
            },
            x: 0.6626239999999999,
            y: 0,
            w: 0.168904,
            charX: 0.02551199999999998
          }
        ],
        color: 0
      },
      {
        bit: {
          char: 'N',
          width: 0.11296000000000002,
          isWordFirst: true,
          isWordLast: false,
          color: 1
        },
        char: 'N',
        frames: [
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.6518719999999999,
            y: 0,
            w: 0.183672,
            charX: 0.042855999999999984
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.49663999999999997,
            y: 0,
            w: 0.185016,
            charX: 0.04352799999999999
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.33120800000000006,
            y: 0,
            w: 0.17975200000000002,
            charX: 0.040895999999999995
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.15868,
            y: 0,
            w: 0.17956,
            charX: 0.04079999999999998
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.155576,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.8315279999999998,
            y: 0.2,
            w: 0.168472,
            charX: 0.04051199999999997
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.6518719999999999,
            y: 0.2,
            w: 0.183672,
            charX: 0.042855999999999984
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.49663999999999997,
            y: 0.2,
            w: 0.185016,
            charX: 0.04352799999999999
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.33120800000000006,
            y: 0.2,
            w: 0.17975200000000002,
            charX: 0.040895999999999995
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.15868,
            y: 0.2,
            w: 0.17956,
            charX: 0.04079999999999998
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0.2,
            w: 0.155576,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: true,
              isWordLast: false,
              color: 1
            },
            x: 0.8315279999999998,
            y: 0,
            w: 0.168472,
            charX: 0.04051199999999997
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'O',
          width: 0.12160000000000003,
          isWordFirst: false,
          isWordLast: false,
          color: 1
        },
        char: 'O',
        frames: [
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8355439999999998,
            y: 0,
            w: 0.164456,
            charX: 0.02785599999999998
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.681656,
            y: 0,
            w: 0.178656,
            charX: 0.02852799999999999
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5109600000000001,
            y: 0,
            w: 0.17339200000000002,
            charX: 0.025895999999999995
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.33824,
            y: 0,
            w: 0.1732,
            charX: 0.025799999999999983
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.155576,
            y: 0,
            w: 0.176832,
            charX: 0.02761599999999998
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.164216,
            charX: 0.015
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.8355439999999998,
            y: 0.2,
            w: 0.164456,
            charX: 0.02785599999999998
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.681656,
            y: 0.2,
            w: 0.178656,
            charX: 0.02852799999999999
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.5109600000000001,
            y: 0.2,
            w: 0.17339200000000002,
            charX: 0.025895999999999995
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.33824,
            y: 0.2,
            w: 0.1732,
            charX: 0.025799999999999983
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0.155576,
            y: 0.2,
            w: 0.176832,
            charX: 0.02761599999999998
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 1
            },
            x: 0,
            y: 0.2,
            w: 0.164216,
            charX: 0.015
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'T',
          width: 0.09616000000000001,
          isWordFirst: false,
          isWordLast: true,
          color: 1
        },
        char: 'T',
        frames: [
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0,
            y: 0.2,
            w: 0.15443199999999996,
            charX: 0.015
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.8603120000000001,
            y: 0,
            w: 0.13968799999999998,
            charX: 0.028527999999999987
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.6843520000000001,
            y: 0,
            w: 0.16295199999999999,
            charX: 0.025895999999999995
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.51144,
            y: 0,
            w: 0.16275999999999996,
            charX: 0.025799999999999983
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.332408,
            y: 0,
            w: 0.16639199999999998,
            charX: 0.02761599999999998
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.164216,
            y: 0,
            w: 0.16639199999999998,
            charX: 0.02761599999999998
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0,
            y: 0,
            w: 0.15443199999999996,
            charX: 0.015
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.8603120000000001,
            y: 0.2,
            w: 0.13968799999999998,
            charX: 0.028527999999999987
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.6843520000000001,
            y: 0.2,
            w: 0.16295199999999999,
            charX: 0.025895999999999995
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.51144,
            y: 0.2,
            w: 0.16275999999999996,
            charX: 0.025799999999999983
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.332408,
            y: 0.2,
            w: 0.16639199999999998,
            charX: 0.02761599999999998
          },
          {
            bit: {
              char: 'T',
              width: 0.09616000000000001,
              isWordFirst: false,
              isWordLast: true,
              color: 1
            },
            x: 0.164216,
            y: 0.2,
            w: 0.16639199999999998,
            charX: 0.02761599999999998
          }
        ],
        color: 1
      },
      {
        bit: {
          char: 'F',
          width: 0.09680000000000001,
          isWordFirst: true,
          isWordLast: false,
          color: 2
        },
        char: 'F',
        frames: [
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.15443199999999996,
            y: 0.2,
            w: 0.16834399999999994,
            charX: 0.04327199999999997
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.2,
            w: 0.1394,
            charX: 0.015
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.8473040000000001,
            y: 0,
            w: 0.152696,
            charX: 0.04089599999999999
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.6741999999999999,
            y: 0,
            w: 0.1634,
            charX: 0.04079999999999998
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.49879999999999997,
            y: 0,
            w: 0.16703199999999996,
            charX: 0.04261599999999998
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.330608,
            y: 0,
            w: 0.16703199999999996,
            charX: 0.042615999999999966
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.15443199999999996,
            y: 0,
            w: 0.16834399999999994,
            charX: 0.04327199999999997
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.1394,
            charX: 0.015
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.8473040000000001,
            y: 0.2,
            w: 0.152696,
            charX: 0.04089599999999999
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.6741999999999999,
            y: 0.2,
            w: 0.1634,
            charX: 0.04079999999999998
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.49879999999999997,
            y: 0.2,
            w: 0.16703199999999996,
            charX: 0.04261599999999998
          },
          {
            bit: {
              char: 'F',
              width: 0.09680000000000001,
              isWordFirst: true,
              isWordLast: false,
              color: 2
            },
            x: 0.330608,
            y: 0.2,
            w: 0.16703199999999996,
            charX: 0.042615999999999966
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'O',
          width: 0.12160000000000003,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'O',
        frames: [
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3227759999999999,
            y: 0.2,
            w: 0.17814399999999997,
            charX: 0.02827199999999997
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1394,
            y: 0.2,
            w: 0.17679999999999998,
            charX: 0.02759999999999998
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.2,
            w: 0.163832,
            charX: 0.015
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8375999999999999,
            y: 0,
            w: 0.1624,
            charX: 0.025799999999999983
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.665832,
            y: 0,
            w: 0.176832,
            charX: 0.02761599999999998
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.49763999999999997,
            y: 0,
            w: 0.176832,
            charX: 0.02761599999999998
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3227759999999999,
            y: 0,
            w: 0.17814399999999997,
            charX: 0.02827199999999997
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.1394,
            y: 0,
            w: 0.17679999999999998,
            charX: 0.02759999999999998
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.163832,
            charX: 0.015
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.8375999999999999,
            y: 0.2,
            w: 0.1624,
            charX: 0.025799999999999983
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.665832,
            y: 0.2,
            w: 0.176832,
            charX: 0.02761599999999998
          },
          {
            bit: {
              char: 'O',
              width: 0.12160000000000003,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.49763999999999997,
            y: 0.2,
            w: 0.176832,
            charX: 0.02761599999999998
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'U',
          width: 0.11472000000000002,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'U',
        frames: [
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5009199999999998,
            y: 0.2,
            w: 0.17126399999999997,
            charX: 0.028271999999999978
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3162,
            y: 0.2,
            w: 0.16991999999999996,
            charX: 0.027599999999999972
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.163832,
            y: 0.2,
            w: 0.16918399999999997,
            charX: 0.02723199999999998
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.2,
            w: 0.15704799999999997,
            charX: 0.015
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.842664,
            y: 0,
            w: 0.15733599999999998,
            charX: 0.027615999999999984
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.674472,
            y: 0,
            w: 0.16995199999999996,
            charX: 0.027615999999999974
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.5009199999999998,
            y: 0,
            w: 0.17126399999999997,
            charX: 0.028271999999999978
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.3162,
            y: 0,
            w: 0.16991999999999996,
            charX: 0.027599999999999972
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.163832,
            y: 0,
            w: 0.16918399999999997,
            charX: 0.02723199999999998
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.15704799999999997,
            charX: 0.015
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.842664,
            y: 0.2,
            w: 0.15733599999999998,
            charX: 0.027615999999999984
          },
          {
            bit: {
              char: 'U',
              width: 0.11472000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.674472,
            y: 0.2,
            w: 0.16995199999999996,
            charX: 0.027615999999999974
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'N',
          width: 0.11296000000000002,
          isWordFirst: false,
          isWordLast: false,
          color: 2
        },
        char: 'N',
        frames: [
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6721839999999998,
            y: 0.2,
            w: 0.16950399999999996,
            charX: 0.02827199999999997
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.48611999999999994,
            y: 0.2,
            w: 0.16815999999999998,
            charX: 0.02759999999999998
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.333016,
            y: 0.2,
            w: 0.16742399999999996,
            charX: 0.02723199999999997
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.15704799999999997,
            y: 0.2,
            w: 0.16761599999999996,
            charX: 0.02732799999999997
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0.2,
            w: 0.156472,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.844424,
            y: 0,
            w: 0.155576,
            charX: 0.027615999999999974
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.6721839999999998,
            y: 0,
            w: 0.16950399999999996,
            charX: 0.02827199999999997
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.48611999999999994,
            y: 0,
            w: 0.16815999999999998,
            charX: 0.02759999999999998
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.333016,
            y: 0,
            w: 0.16742399999999996,
            charX: 0.02723199999999997
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.15704799999999997,
            y: 0,
            w: 0.16761599999999996,
            charX: 0.02732799999999997
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.156472,
            charX: 0.015
          },
          {
            bit: {
              char: 'N',
              width: 0.11296000000000002,
              isWordFirst: false,
              isWordLast: false,
              color: 2
            },
            x: 0.844424,
            y: 0.2,
            w: 0.155576,
            charX: 0.027615999999999974
          }
        ],
        color: 2
      },
      {
        bit: {
          char: 'D',
          width: 0.11504000000000002,
          isWordFirst: false,
          isWordLast: true,
          color: 2
        },
        char: 'D',
        frames: [
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.8416879999999998,
            y: 0.2,
            w: 0.158312,
            charX: 0.028271999999999974
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.65428,
            y: 0.2,
            w: 0.18523999999999996,
            charX: 0.02759999999999998
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.50044,
            y: 0.2,
            w: 0.184504,
            charX: 0.027231999999999985
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.32466399999999995,
            y: 0.2,
            w: 0.18469599999999997,
            charX: 0.02732799999999997
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.156472,
            y: 0.2,
            w: 0.187064,
            charX: 0.02851199999999999
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0,
            y: 0.2,
            w: 0.17055199999999998,
            charX: 0.015
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.8416879999999998,
            y: 0,
            w: 0.158312,
            charX: 0.028271999999999974
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.65428,
            y: 0,
            w: 0.18523999999999996,
            charX: 0.02759999999999998
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.50044,
            y: 0,
            w: 0.184504,
            charX: 0.027231999999999985
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.32466399999999995,
            y: 0,
            w: 0.18469599999999997,
            charX: 0.02732799999999997
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0.156472,
            y: 0,
            w: 0.187064,
            charX: 0.02851199999999999
          },
          {
            bit: {
              char: 'D',
              width: 0.11504000000000002,
              isWordFirst: false,
              isWordLast: true,
              color: 2
            },
            x: 0,
            y: 0,
            w: 0.17055199999999998,
            charX: 0.015
          }
        ],
        color: 2
      }
    ]
  }
};
module.exports = logo;
